import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next/';

import TipList from '../TipList/TipList';

import classes from './RelatedTipList.module.scss';
import Props from './RelatedTipList.props';
import Button from '@components/ui/Button/Button';

const RelatedTipList = ({ tips, restCount, category, buttonLink, ...restProps }: Props) => {
  const { t } = useTranslation();
  const maxAmount = 6;

  const items = [...tips]
    .sort((a, b) => {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    })
    .splice(0, maxAmount);

  return (
    <div className={classes.RelatedTipList} {...restProps}>
      <div className={classes.TipListContainer}>
        <TipList largeTips tips={items} />
        {tips.length >= maxAmount && <div className={classes.Gradient} />}
      </div>
      {tips.length >= maxAmount && (
        <h2 className={cn(classes.Title)}>
          {t('DOMAIN.BUCKETLIST.CATEGORY_ARTICLES_COUNT', { count: restCount, category })}
        </h2>
      )}
      <Button size="sm" theme="primary" href={buttonLink} className={classes.Button}>
        {t('DOMAIN.BUCKETLIST.SHOW_ALL')}
      </Button>
    </div>
  );
};

export default RelatedTipList;
